import { select, put, delay } from 'redux-saga/effects';
import API from '@utils/api';
// import AppActions from './AppRedux';
import AuthActions from './AuthRedux';
import logger from '@utils/logger';

const REFRESH_THRESHOLD = 300000;

export function* refreshAuthToken() {
  const state = yield select();
  const { auth } = state;

  if (!auth.token) {
    return;
  }
  logger.log('refreshing token');

  const { authToken, refreshToken } = auth.token;
  try {
    const { result: newAuthToken } = yield API.getAuthToken({
      authToken,
      refreshToken
    });
    yield put(
      AuthActions.setLoggedIn({
        authToken: newAuthToken,
        refreshToken
      })
    );
  } catch (err) {
    logger.log('refreshAuthToken Error', err);
    yield put(AuthActions.setLoggedOut());
  }
}

export function* loadUser() {
  // yield put(AppActions.setLoading(true));
  const { result: user } = yield API.getUserProfile();
  yield put(AuthActions.setUser(user));
  // yield put(AppActions.setLoading(false));
}

export function* storeToken(action) {
  const { token } = action;
  const { authToken, refreshToken } = token;
  API.setAuthHeader(authToken);

  localStorage.setItem('admin_authToken', authToken);
  localStorage.setItem('admin_refreshToken', refreshToken);

  yield delay(REFRESH_THRESHOLD);
  yield put(AuthActions.setRefreshAuthRequest());
  yield true;
}

export function* storeUser(action) {
  const { user } = action;
  localStorage.setItem('admin_user', JSON.stringify(user));
  yield true;
}

export function* clearToken() {
  API.setAuthHeader(null);
  localStorage.removeItem('admin_authToken');
  localStorage.removeItem('admin_refreshToken');
  localStorage.removeItem('admin_user');
  yield true;
}
